import { STATUS } from '@front-app/constants/state';
import { isEmptyLocation } from '@front-app/services/parse';
import { PartialUser, UserSalutation } from '../UserApi/UserModel';
import {
	EventV2,
	EventV2Result,
	FullEventParticipant,
	RawPublicEventData,
	PublicEventData,
} from './EventModel';

export function parseEvents(rawEvents: EventV2Result[]): EventV2[] {
	return rawEvents.map(parseEvent);
}

export function parsePublicEventData(rawPublicEvent: RawPublicEventData): PublicEventData {
	if (rawPublicEvent.isPublic) {
		return {
			isPublic: rawPublicEvent.isPublic,
			item: parseEvent(rawPublicEvent.item),
		};
	}
	return {
		isPublic: false,
		item: null,
	};
}

export function parseEvent(rawEvent: EventV2Result): EventV2 {
	return {
		...rawEvent,
		startDate: new Date(rawEvent.startDate),
		endDate: rawEvent.endDate ? new Date(rawEvent.endDate) : new Date(rawEvent.startDate),
		location: {
			street1: rawEvent.location.street1,
			street2: rawEvent.location.street2,
			city: rawEvent.location.city,
			provStateRegion: rawEvent.location.provStateRegion,
			country: rawEvent.location.country,
			postalCode: rawEvent.location.postalCode,
			empty: isEmptyLocation(rawEvent.location),
		},
	};
}

export const participantToAsyncUser = (participant: FullEventParticipant): PartialUser => ({
	id: participant.timedRightId,
	salutation: UserSalutation.NONE,
	firstName: participant.name,
	lastName: '',
	middleName: '',
	displayName: '',
	authenticated: true,
	verified: true,
	status: STATUS.SUCCESS,
});
